import { render, staticRenderFns } from "./STrumb.vue?vue&type=template&id=0f770c91"
import script from "./STrumb.vue?vue&type=script&lang=js"
export * from "./STrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports